module.exports = __webpack_public_path__ + "img/smotly.e27cb55a.png";